import { combatLockRemaining } from './travel.js';
/**
 * Health coming back on its own (ADR 0031). Out of combat only — the same
 * ten seconds after the last blow that lock travel and redden the screen — so
 * a potion is what saves a fight and a pause is what follows one. Without
 * it, every point lost was bought back in gold, and healing ate most of what
 * the hunting paid.
 */
/** Share of the maximum health regained per second out of combat: empty to full in about 33 s. */
export const HEALTH_REGEN_SHARE_PER_SECOND = 0.03;
/** Whether health is coming back: alive, hurt, and out of combat. */
export function isRecovering(hp, maxHealth, lastCombatAt, now) {
    return hp > 0 && hp < maxHealth && combatLockRemaining(lastCombatAt, now) === 0;
}
/**
 * Health regained over `elapsedMs`, fractional: the room keeps the fraction
 * between ticks and shows whole points.
 */
export function healthRegained(maxHealth, elapsedMs) {
    return (maxHealth * HEALTH_REGEN_SHARE_PER_SECOND * Math.max(0, elapsedMs)) / 1000;
}
/**
 * Whether a healing potion has anything to do: at full health it would be
 * swallowed for nothing, so the server keeps it in the bag.
 */
export function canDrinkHeal(hp, maxHealth) {
    return hp < maxHealth;
}
//# sourceMappingURL=recovery.js.map